<form [formGroup]="internalFormGroup">
  <digires-state-indicator [formCtrlName]="fullFormCtrlName" [readOnly]="readOnly" [readOnlyReason]="readOnlyReason" [finModel]="finModel"></digires-state-indicator>
  <mat-form-field [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label>
      <input matInput
             formControlName="value"
             type="month"
             min="{{minStr}}"
             max="{{maxStr}}"
             [required]="required && !readOnly"
             [readonly]="readOnly"
             (change)="onInputChanged()">
    </label>
    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-icon *ngIf="!!tooltip" class="tooltip-icon" matTooltipPosition="above" matTooltip="{{tooltip}}" svgIcon="tooltip"></mat-icon>
  <mat-icon *ngIf="!!finModel" class="warning-triangle" [class.transparent]="!finModel.hasUpload || !finModel.isReadable(fullFormCtrlName) || finModel.isRead(fullFormCtrlName)"
            matTooltip="Note: The value in this field was not populated by the most recent upload of the financial model">
    warning
  </mat-icon>
</form>
